import React from 'react';
import { useReveal } from '../../hooks/useReveal';

export const Reveal = ({ children, delay = "" }) => {
  const ref = useReveal();
  return <div ref={ref} className={`rv${delay ? ` d${delay}` : ""}`}>{children}</div>;
};